module.exports = __webpack_public_path__ + "static/media/icon_arrow_nav.7f200e12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_arrow_nav.svg
// module id = 614
// module chunks = 0